module.exports = __webpack_public_path__ + "static/img/sl01.015cda702.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/sl01.png
// module id = wnnU
// module chunks = 0